// extracted by mini-css-extract-plugin
export default {"aside":"Aside-module__aside___0QmCA"};